module.exports = __webpack_public_path__ + "static/media/report.285d3449.jpg";